
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
const AppbarState = namespace("Appbar");

@Component({
  name: "CarrinhoSemPedidosContainer",
  components: {},
})
export default class CarrinhoSemPedidosContainer extends Vue {
  @AppbarState.Getter
  private getAppbarStatus!: any;

  closeDrawer() {
    this.getAppbarStatus.carrinhoDrawer = !this.getAppbarStatus.carrinhoDrawer;
  }

  onBtnSelecItensClick() {
    this.closeDrawer();
    if (["/produtos", "/home"].indexOf(this.$router.currentRoute.path) < 0) {
      this.$router.push('/produtos');
    }
  }
}
